import { Box } from '@mui/material';
import { ContentType } from '@/common/constants/ContentTypes';

import PostDisplay from '@/components/PostDisplay/PostDisplay';
import { VideoPost } from '@/components/VideoPost/VideoPost';
import { CommentPropTypes } from '@/components/PostBase/PostBase.types';
import { DiscussionPost } from '../DiscussionPost';
import { ArticlePost } from '../ArticlePost';

export function DisplayFeed({
  feedContent,
  collapsed,
  onToggleCollapse,
  groupPage = false,
}): JSX.Element {
  const { contentType } = feedContent;
  const comments: CommentPropTypes = {
    collapsed,
    collapsible: true,
    onToggleCollapse,
    comments: feedContent.comments,
    show: true,
  };
  function getComponent() {
    switch (contentType) {
      case ContentType.VILLAGE_FEED:
        return (
          <PostDisplay
            commentProps={comments}
            publication={feedContent}
            user={feedContent?.author}
            chipProps={{
              variant: 'highlighted',
              color: 'primary',
              label: 'author',
            }}
            link={{
              label: feedContent?.source?.title,
              url: `/vlg/${feedContent?.source?.slug}`,
            }}
            id={feedContent.id || feedContent.contentId}
          />
        );
      case ContentType.DISCUSSIONS:
        return (
          <DiscussionPost
            comments={comments}
            feedContent={feedContent}
            link={{
              label: feedContent?.source?.title,
              url: `/discussions/${feedContent?.slug}`,
            }}
          />
        );
      case ContentType.PRODUCTS:
        return (
          <ArticlePost
            feedContent={feedContent}
            comments={comments}
            link={{
              label: feedContent?.source?.title,
              url: `/product/${feedContent?.slug}`,
            }}
          />
        );
      case ContentType.RESOURCES:
        if (feedContent.resourceType?.type === 'video') {
          return (
            <VideoPost
              publication={feedContent}
              user={feedContent?.author}
              link={{
                label: feedContent?.source?.title,
                url: `/resource/${feedContent?.slug}`,
              }}
            />
          );
        }
        return (
          <ArticlePost
            feedContent={feedContent}
            comments={comments}
            link={{
              label: feedContent?.source?.title,
              url: `/resource/${feedContent?.slug}`,
            }}
          />
        );
      case ContentType.ARTICLE:
      case ContentType.AFFILIATE_PRODUCT:
      case ContentType.RLS:
        return groupPage ? (
          <ArticlePost
            feedContent={feedContent}
            comments={comments}
            link={{
              label: feedContent?.source?.title,
              url: `/resource/${feedContent?.slug}`,
            }}
          />
        ) : null;
      case ContentType.VIDEO:
        return groupPage ? (
          <VideoPost
            publication={feedContent}
            user={feedContent?.author}
            link={{
              label: feedContent?.source?.title,
              url: `/resource/${feedContent?.slug}`,
            }}
          />
        ) : null;
      default:
        return null;
    }
  }

  const component = getComponent();
  return component ? <Box>{component}</Box> : null;
}
